import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';
import { CommonPagesService } from '../../common-pages.service';
import data from 'src/assets/json/states.json';
import { paybevEnvironment } from 'src/environments/environment';
import { differenceInCalendarDays } from 'date-fns';
import moment from 'moment';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { FormControl, Validators } from '@angular/forms';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';
import { CdkDrag, CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';
import {
  NonAlcSitesTransactionType,
  ResponseStatus,
  SiteType,
  TransactionsType,
  ValidationMessage,
} from '../../enum';
import { forkJoin } from 'rxjs';
import { applyProgramVisibilityCascade } from '../../program-period-visibility-cascade';
@Component({
  selector: 'app-add-update-sites',
  templateUrl: './add-update-sites.component.html',
  styleUrls: ['./add-update-sites.component.scss'],

  standalone: false,
})
export class AddUpdateSitesComponent implements OnInit {
  public mask = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  };

  isVisibleSiteDrawer = true;
  sitebutton: any;
  paybevEnvironmentUrl: any = paybevEnvironment.URL;
  @Output() hideSiteDrawer = new EventEmitter();
  @Input() selectedSiteData: any;
  @Input() SelectedSiteTab: any;
  LineStreetAddress = false;
  @ViewChildren('startingBalance') startingBalanceFocus: any;
  @ViewChildren('datePick') datePick: any;
  siteNameModel: any = '';
  isSameAddressFlag: any;
  tagNameOrder: any = null;
  tagNameWidth: any = '150px';
  isLoadingQBOClass: boolean = false;
  listOfAllocatedSites: any;
  isSiteSelected: any;
  url: any;
  uploadResult: any;
  listOfRoles: any;
  listOfAccounts: any;
  listOfProductService: any;
  sitesData: any;
  isLoadingUpload: any = false;
  isLoadingOne: any = false;
  isLoadingSaveClose: any = false;
  pageSize: number = 100;
  sortBy: any = 'asc';
  sortField: string = 'CreatedOn';
  today = new Date();
  todayDate = new FormControl(moment());
  pageNumber: number = 1;
  filterByStatus: any = 'All';
  sameAccount: any = false;
  listOfCategory: any;
  totalRecords: any;
  newSiteAddUpdateData: any;
  newSelectedSiteId: any = null;

  searchText: any = '';
  searchTextProgramP: any = '';
  openClassDD: boolean = false;
  tabIndex = 0;
  listOfTransactionClass: any;
  getPreferredPartnerData: any;
  getPreferredVendorData: any;
  loading = false;
  isVisibleRoleDrawer = false;
  isVisibleProgramPeriodDrawer = false;
  isVisiblePreferredPartnersDrawer = false;
  isVisiblePreferredVendorsDrawer = false;
  selectedPPartnerData: any;
  deleteConfirmVisible = false;
  isVisibleEstimateModal = false;
  isVisibleBillModal = false;
  isVisibleInvestmentModal = false;
  isVisibleExpenseModal = false;

  deleteProgramPConfirmVisible = false;
  deletePVendorsConfirmVisible = false;
  deletePPartnersConfirmVisible = false;

  selectedProgramPeriodData: any;
  selectedPreferredPartnersData: any;
  selectedPreferredVendorsData: any;
  pageRecord: number = 100;
  timer: any = null;
  isDataLoaded = false;
  oldSearchText: string = '';
  radioValue: any = 'A';
  selectedPreferredVData: any;
  page: number = 1;
  currentUserEmail: any = JSON.parse(localStorage.getItem('UserInfo') || '{}')
    .email;
  rToken = localStorage.getItem('RefreshToken');

  getAllProgramPData: any;
  apiAllVendorsData: any;

  loadingDeleteProgram: any = false;

  isDeletingVendor: boolean = false;
  currentAddingVendor: any = '';
  inputValue?: string;
  isLoadingVendorSearch: any;
  startPosition: any;
  vendorsDBList: any[] = [];

  selectedFilter: any;
  rolePermissions: any;
  canDeleteInvestor: boolean = false;
  canAddInvestor: boolean = false;
  isLoadingPartnerSearch: boolean = false;
  isDeletingInvestor: boolean = false;
  inputValuePartner?: string;
  partnerDBList: any[] = [];
  currentAddingInvestor: any = '';
  getAllPPartnersData: any = [''];
  apiAllNonAlcData: any = [''];
  searchTextPPartner: any;
  nonalcResult: any;

  apiUsersData: any[] = [];
  isVisibleTagGroup: any = false;
  isVisibleTag: any = false;
  tags: any[] = [];
  tagsCopy: any[] = [];
  canAddTag: boolean = false;
  canEditTag: boolean = false;
  canDeleteTag: boolean = false;
  invalidtagname: boolean = false;
  isEnableButton: boolean = false;
  siteId: any;
  selectedTagData: any;
  selectedTagGroupData: any;
  isTagGroupAdded: boolean = false;
  isLoadingTag: boolean = false;
  isDeletingTag: boolean = false;
  groupTitle: any = 'Add Tag Group';
  tagTitle: any = 'Add Tag';
  tagname: any = '';
  selectedData: any;
  color: any = '#FFFFFF';
  isVisibleStartingBalancePopover: boolean = false;
  startingBalanceNonAlc: any;
  isVisibleDatePopover: boolean = false;
  dateNonAlc: any;
  expandSet = new Set<number>();
  tagGroupData: any[] = [''];
  validationMessage = ValidationMessage;
  listOfGroups: any = [];
  listOfSiteTypes: any = [];
  listOfQBOCustomers: any = [];

  canAddProgram: any;
  canEditProgram: any;
  canDeleteProgram: any;
  isUpdatingDetails: boolean = false;
  currentStartingBalanceAmount: any;
  isDateError: boolean = false;
  maxSiteDate: Date;
  minSiteDate: Date;
  invalidDate: boolean = false;
  isVisibleDepositModal = false;
  isVisibleCreditModal = false;
  isVisibleRefundModal = false;
  isVisibleITModal = false;
  isExportingData: boolean = false;
  // filterSearchValue: string = "";
  selectedFilters: any = {
    'Transaction Type': [],
  };
  listOfTransactionsTypes: any = [];
  selectedTransactionTypes: string = '';

  @ViewChild('address1Field') address1Field: any;
  @ViewChild('zipcode') zipcode: any;
  @ViewChild('categoryDD') categoryDD: any;
  @ViewChild('productDD') productDD: any;
  @ViewChild('processFee') processFee: any;
  colsPrograms: any[] = [
    {
      title: 'Program Label',
      width: '180',
      sortDir: null,
    },
    {
      title: 'Start Date',
      width: '150',
      sortDir: null,
    },
    {
      title: 'End Date',
      width: '150',
      sortDir: null,
    },
    {
      title: 'Default',
      width: '100',
      sortDir: null,
    },
    {
      title: 'Status',
      width: '100',
      sortDir: null,
    },
    {
      title: 'Linked',
      width: '100',
      sortDir: null,
    },
    {
      title: 'Action',
      width: '80',
      sortDir: null,
    },
  ];
  colsPartners: any[] = [
    {
      title: 'Rep Name',
      width: '150',
      sortTitle: 'InvestorDisplayName',
      sortDir: null,
    },
    {
      title: 'Address',
      width: '180',
      sortDir: null,
    },
    {
      title: 'Phone No.',
      width: '100',
      sortTitle: 'PhoneNumber',
      sortDir: null,
    },
    {
      title: 'Email',
      width: '150',
      sortTitle: 'Email',
      sortDir: null,
    },
    {
      title: 'Action',
      width: '80',
      sortDir: null,
    },
  ];
  colsVendors: any[] = [
    {
      title: 'Vendor Name',
      width: '180',
      sortTitle: 'VendorDisplayName',
      sortDir: null,
    },
    {
      title: 'Address',
      width: '220',
      sortDir: null,
    },
    {
      title: 'Phone No.',
      width: '120',
      sortTitle: 'PhoneNumber',
      sortDir: null,
    },
    {
      title: 'Email',
      width: '150',
      sortTitle: 'Email',
      sortDir: null,
    },
    {
      title: 'Action',
      width: '80',
      sortDir: null,
    },
  ];
  isLoadingTagGroup: boolean = false;
  colsNonAlc: any[] = [
    {
      title: 'Date',
      width: '120',
      sortTitle: 'Date',
      sortDir: null,
    },
    {
      title: 'Transaction Type',
      width: '180',
      isFilterable: true,
      isVisible: false,
      filterOptions: [],
      filteredFilterOptions: [],
      selectedValues: [] as any[],
      sortDir: null,
    },
    {
      title: 'Invoice No./Bill No.',
      width: '130',
      sortTitle: 'ReferenceNo',
      sortDir: null,
    },
    {
      title: 'Vendor',
      width: '150',
      sortTitle: 'Vendor',
      sortDir: null,
    },
    {
      title: 'Supplier',
      width: '120',
      sortTitle: 'Supplier',
      sortDir: null,
    },
    {
      title: 'Debit',
      width: '120',
      sortDir: null,
    },
    {
      title: 'Credit',
      width: '120',
      sortDir: null,
    },
    {
      title: 'Action',
      width: '80',
      sortDir: null,
    },
  ];

  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService,
    private msg: NzMessageService,
    private _iS: InnerPagesService,
    private currency: CurrencyPipe,
    private _datepipe: DatePipe
  ) {
    _fS.siteForm_fb();
    _fS.tagsGroupForm_fb();
    _fS.tagForm_fb();

    this.minSiteDate = new Date(2010, 0, 1);
    this.maxSiteDate = new Date(2050, 11, 31);
  }
  listOfStates: any = data.States;
  disabledDate = (current: Date): boolean =>
    // Can not select days after today
    differenceInCalendarDays(current, this.today) > 0;

  // current.getTime() > this.today.getTime();
  ngOnInit(): void {
    this.siteId;
    this.rToken = btoa(
      unescape(encodeURIComponent(localStorage.getItem('RefreshToken') || ''))
    );

    this.currentUserEmail = btoa(
      unescape(encodeURIComponent(this.currentUserEmail))
    );
    // this.getAllAccount();
    // this.getAllSiteTypes();
    if (this.SelectedSiteTab == 1) {
      this.updateSiteFormValidation(true);
    } else {
      this.updateSiteFormValidation(false);
    }

    this.fetchDropdownRecords();
    this.getNonAlcTransactionTypeFilters();

    // this.getAllAgencys()
    this.getGenericPopulateRecords();
    this.isSiteSelected =
      localStorage.getItem('IsSiteSelected') == 'true' ? true : false;
  }

  get SiteType() {
    return SiteType;
  }

  updateSiteFormValidation(isSupplier: boolean = false) {
    if (isSupplier) {
      this._fS.siteForm.get('class').clearValidators();
      this._fS.siteForm.get('class').updateValueAndValidity();

      this._fS.siteForm.get('category').clearValidators();
      this._fS.siteForm.get('category').updateValueAndValidity();

      this._fS.siteForm.get('product').clearValidators();
      this._fS.siteForm.get('product').updateValueAndValidity();

      this._fS.siteForm.get('processFee').clearValidators();
      this._fS.siteForm.get('processFee').updateValueAndValidity();

      this._fS.siteForm.get('nonAlcFee').clearValidators();
      this._fS.siteForm.get('nonAlcFee').updateValueAndValidity();

      this._fS.siteForm.get('startingBalance').clearValidators();
      this._fS.siteForm.get('startingBalance').updateValueAndValidity();

      this._fS.siteForm.get('status').clearValidators();
      this._fS.siteForm.get('status').updateValueAndValidity();

      this._fS.siteForm.get('nonAlcStatus').clearValidators();
      this._fS.siteForm.get('nonAlcStatus').updateValueAndValidity();

      this._fS.siteForm.get('programVisibility').clearValidators();
      this._fS.siteForm.get('programVisibility').updateValueAndValidity();

      this._fS.siteForm.get('tagVisibility').clearValidators();
      this._fS.siteForm.get('tagVisibility').updateValueAndValidity();
    } else {
      this._fS.siteForm.get('class')?.setValidators(Validators.required);
      this._fS.siteForm.get('class')?.updateValueAndValidity();

      this._fS.siteForm.get('category')?.setValidators(Validators.required);
      this._fS.siteForm.get('category')?.updateValueAndValidity();

      this._fS.siteForm.get('product')?.setValidators(Validators.required);
      this._fS.siteForm.get('product')?.updateValueAndValidity();

      this._fS.siteForm.get('processFee')?.setValidators(Validators.required);
      this._fS.siteForm.get('processFee')?.updateValueAndValidity();

      this._fS.siteForm.get('nonAlcFee')?.setValidators(Validators.required);
      this._fS.siteForm.get('nonAlcFee')?.updateValueAndValidity();

      this._fS.siteForm
        .get('startingBalance')
        ?.setValidators(Validators.required);
      this._fS.siteForm.get('startingBalance')?.updateValueAndValidity();

      this._fS.siteForm.get('status')?.setValidators(Validators.required);
      this._fS.siteForm.get('status')?.updateValueAndValidity();

      this._fS.siteForm.get('nonAlcStatus')?.setValidators(Validators.required);
      this._fS.siteForm.get('nonAlcStatus')?.updateValueAndValidity();

      this._fS.siteForm
        .get('programVisibility')
        ?.setValidators(Validators.required);
      this._fS.siteForm.get('programVisibility')?.updateValueAndValidity();

      this._fS.siteForm
        .get('tagVisibility')
        ?.setValidators(Validators.required);
      this._fS.siteForm.get('tagVisibility')?.updateValueAndValidity();
    }
  }

  fetchDropdownRecords() {
    forkJoin([
      // this._iS.getInternalUserDropdown(),
      this._iS.getAccountDropdownList(this.SelectedSiteTab),
      this._cpS.GetAllAccountTypesDropdown(
        this.SelectedSiteTab == SiteType.Operator ? 1 : 2
      ),
      this._cpS.getQBOCustomers(),
    ]).subscribe({
      next: ([res1, res2, res3]) => {
        // if (res1.responseStatus === ResponseStatus.success) {
        //   this.usersList = res1.result;
        // } else {
        //   this._cS.displayMessage('error', res1.message);
        // }
        if (res1.responseStatus === ResponseStatus.success) {
          this.listOfAccounts = res1.result;
        } else {
          this._cS.displayMessage('error', res1.message);
        }

        //type dropdown api response handle
        if (res2.responseStatus == ResponseStatus.success) {
          this.listOfSiteTypes = res2.result;
        }

        //type dropdown api response handle
        if (res3.responseStatus == ResponseStatus.success) {
          this.listOfQBOCustomers = res3.result;
        }

        this.patchDataToForm();
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }

  patchDataToForm() {
    if (this.selectedSiteData != null) {
      var selectedSiteType = this.listOfSiteTypes.find(
        (type: any) => type.id == this.selectedSiteData?.siteType?.id
      );
      // find accountName in listOfAccounts if not found then add it to listOfAccounts list
      var selectedAccount = this.listOfAccounts?.find(
        (acc: any) => acc.name == this.selectedSiteData?.accountName
      );
      if (!selectedAccount) {
        this.listOfAccounts.push({
          name: this.selectedSiteData?.accountName,
          id: this.selectedSiteData?.accountId,
          address1: this.selectedSiteData.address1,
          address2: this.selectedSiteData.address2,
          city: this.selectedSiteData.city,
          state: this.selectedSiteData.state,
          zipcode: this.selectedSiteData.zipcode,
          country: this.selectedSiteData.country,
        });
      }
      //patchvalue to form while edit

      if (!this.listOfStates.includes(this.selectedSiteData.state)) {
        this.listOfStates.push(this.selectedSiteData.state);
      }

      this._fS.siteForm.patchValue({
        siteProfile: this.selectedSiteData.profile,
        siteName: this.selectedSiteData.name,
        accountName: this.selectedSiteData.accountName,
        address1: this.selectedSiteData.address1,
        address2: this.selectedSiteData.address2,
        city: this.selectedSiteData.city,
        state: this.selectedSiteData.state,
        zipcode: this.selectedSiteData.zipcode,
        country: this.selectedSiteData.country,
        siteType: selectedSiteType ? selectedSiteType.id : '',
        class: this.selectedSiteData.class,
        category: this.selectedSiteData.category,
        product: this.selectedSiteData.productServices,
        processFee: this.selectedSiteData.processfee,
        nonAlcFee: this.selectedSiteData.nonAlcFee,
        startingBalance: this.selectedSiteData.startingBal,
        date: this.selectedSiteData.date,
        status: String(this.selectedSiteData.status),
        nonAlcStatus: this.selectedSiteData.nonAlcStatus,
        programVisibility: this.selectedSiteData.isProgramPeriodVisible,
        tagVisibility: this.selectedSiteData.isTagVisible,
        isSameAddress: this.selectedSiteData.isSameAddress,
      });

      this.formatAmount(this.selectedSiteData.startingBal);
      this.LineStreetAddress = this.selectedSiteData.isAddLine;
      this.newSelectedSiteId =
        this.selectedSiteData != null ? this.selectedSiteData.id : '';
      this.uploadResult = this.selectedSiteData.profile;
      this.isSameAddressFlag = this.selectedSiteData.isSameAddress;
      this.siteNameModel =
        this.SelectedSiteTab != 1
          ? this.selectedSiteData.name
          : this.getQBOSupplierNameById(this.selectedSiteData?.qboSupplierId);
    }
  }

  getQBOSupplierNameById(qboSupplierId: string) {
    let supplier = this.listOfQBOCustomers.find((item: any) => {
      return item.qboSupplierId == qboSupplierId;
    });

    return supplier?.id;
  }

  //get all site types
  getAllSiteTypes() {
    this._cpS
      .GetAllAccountTypesDropdown(
        this.SelectedSiteTab == SiteType.Operator ? 1 : 2
      )
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.listOfSiteTypes = response.result;
        }
      });
  }

  onResizePartners({ width }: NzResizeEvent, col: string): void {
    this.colsPartners = this.colsPartners.map((e) =>
      e.title === col ? { ...e, width: `${width}px` } : e
    );
  }
  onResizePrograms({ width }: NzResizeEvent, col: string): void {
    this.colsPrograms = this.colsPrograms.map((e) =>
      e.title === col ? { ...e, width: `${width}px` } : e
    );
  }
  onResizeVendors({ width }: NzResizeEvent, col: string): void {
    this.colsVendors = this.colsVendors.map((e) =>
      e.title === col ? { ...e, width: `${width}px` } : e
    );
  }
  onResizeTags({ width }: NzResizeEvent, col: string): void {
    this.tagNameWidth = `${width}px`;
  }
  onResizeNonAlc({ width }: NzResizeEvent, col: string): void {
    this.tagNameWidth = `${width}px`;
  }
  //cancel update role
  handleCancel() {
    this.isVisibleSiteDrawer = false;

    if (this.sitebutton == 'SAVE') {
      this.hideSiteDrawer.emit({
        hide: this.isVisibleSiteDrawer,
        data: this.newSiteAddUpdateData,
      });
    } else {
      this.hideSiteDrawer.emit({ hide: this.isVisibleSiteDrawer, data: null });
    }
  }
  addLines() {
    this.LineStreetAddress = true;
    this._fS.siteForm.patchValue({
      address1:
        this._fS.siteForm.get('address1').value != null &&
          this._fS.siteForm.get('address1').value != ''
          ? this._fS.siteForm.get('address1').value +
          '\r\n' +
          this._fS.siteForm.get('address2').value
          : this._fS.siteForm.get('address2').value,
      address2: '',
    });
  }

  // colorPickerShow() {
  //   this.colorPickerVisible = true
  // }
  tabEvent(index: any) {
    this.tabIndex = index;
    if (this.tabIndex == 1) {
      this.pageNumber = 1;
      this.searchText = '';
      this.sortBy = 'desc';
      this.sortField = 'startYear';
      this.getAllPrograms();
    }
    if (this.tabIndex == 2) {
      this.pageNumber = 1;
      this.searchText = '';
      this.sortField = 'Name';
      this.getAllTags(true);
    }
    if (this.tabIndex == 3) {
      this.pageNumber = 1;
      this.searchText = '';
      this.sortField = 'CompanyName';
      this.getAllPPartners();
    }
    if (this.tabIndex == 4) {
      this.pageNumber = 1;
      this.searchText = '';
      this.sortField = 'VendorDisplayName';
      this.getAllPVendors();
    }
    if (this.tabIndex == 5) {
      this.pageNumber = 1;
      this.searchText = '';
      this.sortBy = 'desc';
      this.sortField = 'Date';
      this.setDefaultFilters();
    }
  }

  Onclick(e: any) {
    e.target.value = null;
  }
  onFileChanged(e: any) {
    let reader = new FileReader();
    if (
      e.target.files[0].length > 0 ||
      e.target.files[0].type === 'image/jpeg' ||
      e.target.files[0].type === 'image/png' ||
      e.target.files[0].type === 'image/jpg'
    ) {
      this.url = e.target.files[0];
      reader.readAsDataURL(this.url);
      reader.onload = () => {
        this.url = reader.result;
        this.isLoadingUpload = true;
        // this.isLoadingOne = true
        this._fS.fileupload.set('File', e.target.files[0]);
        this._fS.fileupload.set('Screen', 'SiteProfile');

        this._cpS.fileUpload(this._fS.fileupload).subscribe(
          (response: any) => {
            if (response.responseStatus == ResponseStatus.success) {
              this.uploadResult = response.result[0];
              this._cS.displayMessage('success', response.message);
              this.isLoadingUpload = false;
              // this.isLoadingOne = false
            } else {
              this._cS.displayMessage('error', response.message);
              this.isLoadingUpload = false;
              // this.isLoadingOne = false
            }
          },
          (error: any) => {
            // this._cS.displayMessage('error', error.message);
            this.isLoadingUpload = false;
            // this.isLoadingOne = false
          }
        );
      };
    } else {
      this.msg.error('File type is not allowed');
      this.url = null;
      this.uploadResult = null;
      this.isLoadingUpload = false;
      // this.isLoadingOne = false
    }
  }
  removeLogo() {
    var requestBody = {
      screen: 'SiteProfile',
      filename: this.uploadResult,
    };
    this._cpS.fileDelete(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cS.displayMessage('success', response.message);

        this.url = '';
        this.uploadResult = null;
      } else {
        this._cS.displayMessage('error', response.message);
      }
    });
  }

  todate(value) {
    if (value && value != '__/__/____') {
      if (isNaN(new Date(value).getTime())) {
        this.invalidDate = true;
        this._fS.siteForm.get('date').clearValidators();
        this._fS.siteForm.get('date').updateValueAndValidity();
      } else if (
        new Date(value).getTime() > this.maxSiteDate.getTime() ||
        new Date(value).getTime() < this.minSiteDate.getTime()
      ) {
        this._fS.siteForm.get('date').setValue(new Date(value));
        this.isDateError = true;
        this.invalidDate = true;
      } else {
        this.invalidDate = false;
        this.isDateError = false;
        this._fS.siteForm.get('date').setValue(new Date(value));
      }
    } else {
      this.invalidDate = false;
      this._fS.siteForm.get('date').addValidators(Validators.required);
      this._fS.siteForm.get('date').updateValueAndValidity();
      if (value == '__/__/____') {
        this._fS.siteForm.get('date').setValue(undefined);
        this.isDateError = true;
      }
      this._fS.siteForm.get('date').markAsDirty();
      this._fS.siteForm.get('date').updateValueAndValidity();
    }
  }
  selectedSiteName: any;
  siteNameChange(value) {
    //find name of selected site from listOfQBOCustomers
    let siteSelected = this.listOfQBOCustomers.find(
      (qbo: any) => qbo.id == value
    );
    this.selectedSiteName = siteSelected?.name;

    if (!this.selectedSiteData && this.SelectedSiteTab == SiteType.Supplier) {
      this._fS.siteForm.patchValue({
        address1: siteSelected?.streetAddress1,
        address2: siteSelected?.streetAddress2,
        city: siteSelected?.city,
        state: siteSelected?.state,
        zipcode: siteSelected?.zipCode,
        country: siteSelected?.country,
      });
    }
  }

  handleOk(button?: any) {
    var selectedAccount = this.listOfAccounts?.find(
      (acc: any) => acc.name == this._fS.siteForm.value.accountName
    );
    let selectedQBOCustomer: any;
    if (this.SelectedSiteTab == SiteType.Supplier) {
      selectedQBOCustomer = this.listOfQBOCustomers.find(
        (qbo: any) => qbo.id == this._fS.siteForm.value.siteName
      );
    }

    if (!selectedAccount) {
      //patch null to account name
      this._fS.siteForm.patchValue({ accountName: null });
    }

    var dateValue = this._fS.siteForm.value.date;
    if (this._fS.siteForm.valid && dateValue && this.invalidDate == false) {
      const formValue = this._fS.siteForm.value;
      //find name of selected site type
      var selectedSiteType = this.listOfSiteTypes.find(
        (type: any) => type.id == formValue.siteType
      );
      var siteBody = {
        Id:
          this.selectedSiteData != null
            ? this.selectedSiteData.id
            : this.broofa(),
        Name: selectedQBOCustomer
          ? selectedQBOCustomer.name
          : formValue.siteName.trim(),
        AccountName: formValue.accountName,
        AccountId: selectedAccount.id,
        accountAgencyType: this.SelectedSiteTab,
        Profile: this.uploadResult,
        Address1: formValue.address1,
        Address2: formValue.address2,
        City: formValue.city,
        State: formValue.state,
        Zipcode: formValue.zipcode,
        Country: formValue.country,
        siteType: selectedSiteType,
        Class: formValue.class,
        Category: formValue.category,
        ProductServices: formValue.product,
        Processfee: formValue.processFee == '' ? 0 : formValue.processFee,
        nonAlcFee: formValue.nonAlcFee == '' ? 0 : formValue.nonAlcFee,
        StartingBal:
          this.currentStartingBalanceAmount == ''
            ? 0
            : this.currentStartingBalanceAmount,
        startingNonAlcBal: this.startingBalanceNonAlc,
        Date: new Date(formValue.date),
        CreatedOn: new Date(),
        isSameAddress: formValue.isSameAddress,
        status: formValue.status,
        nonAlcStatus: formValue.nonAlcStatus,
        isProgramPeriodVisible: formValue.programVisibility,
        isTagVisible: formValue.tagVisibility,
        isAddLine: this.LineStreetAddress,
        qboSupplierId: selectedQBOCustomer
          ? selectedQBOCustomer.qboSupplierId
          : null,
      };
      this.siteNameModel = formValue.siteName.trim();

      //add or edit Account data
      if (this.selectedSiteData != null) {
        this.UpdateSiteData(siteBody, button);
      } else {
        this.addSiteData(siteBody, button);
      }
    } else {
      if (!dateValue) {
        this.isDateError = true;
      }
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.siteForm);
    }
  }
  broofa() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  private moveItemInArrayIfAllowed(
    array: any[],
    fromIndex: number,
    toIndex: number
  ): void {
    const from = this.clamp(fromIndex, array.length - 1);
    const to = this.clamp(toIndex, array.length - 1);

    if (from === to) {
      return;
    }

    const target = array[from];
    const delta = to < from ? -1 : 1;

    const affectedItems = array.filter((item, index) =>
      delta > 0 ? index >= from && index <= to : index >= to && index <= from
    );

    if (affectedItems.some((i) => i.isDefault)) {
      return;
    }

    for (let i = from; i !== to; i += delta) {
      array[i] = array[i + delta];
    }

    array[to] = target;
  }

  private clamp(value: number, max: number): number {
    return Math.max(0, Math.min(max, value));
  }

  /**
   * Predicate function that only allows even numbers to be
   * sorted into even indices and odd numbers at odd indices.
   */

  sortPredicateForDisableItem(items: any) {
    return function (index: number, item: CdkDrag, drop: CdkDropList) {
      return items[index].isDefault == false;
    };
  }
  drop(event: CdkDragDrop<string[]>): void {
    this.moveItemInArrayIfAllowed(
      this.tagGroupData,
      event.previousIndex,
      event.currentIndex
    );
  }

  addSiteData(siteBody: any, button?: any) {
    var selectedClass = this.listOfTransactionClass.find(
      (cls: any) => cls.id == this._fS.siteForm.value.class
    );
    const isInactiveClass = selectedClass?.isActive === false;
    if (selectedClass && (selectedClass?.isMapped || isInactiveClass)) {
      this._fS.siteForm.patchValue({
        class: '',
      });
    }
    if (!selectedClass?.isMapped && !isInactiveClass) {
      button == 'SAVECLOSE'
        ? (this.isLoadingSaveClose = true)
        : (this.isLoadingOne = true);

      this._cpS.createSite(siteBody).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          this.newSelectedSiteId = response.result?.id;
          this.selectedSiteData = response.result;
          this.newSiteAddUpdateData = response.result;
          //hide unit drawer
          if (button == 'SAVECLOSE') {
            this.isVisibleSiteDrawer = false;
            this.hideSiteDrawer.emit({
              hide: this.isVisibleSiteDrawer,
              data: response.result,
            });
            this.sitebutton = 'SAVECLOSE';
          } else {
            this.sitebutton = 'SAVE';
          }
          button == 'SAVECLOSE'
            ? (this.isLoadingSaveClose = false)
            : (this.isLoadingOne = false);

          if (this.SelectedSiteTab == 1) {
            this.updateSiteFormValidation(false);
          }
        } else {
          this._cS.displayMessage('error', response.message);
          button == 'SAVECLOSE'
            ? (this.isLoadingSaveClose = false)
            : (this.isLoadingOne = false);
        }
      });
    } else {
    }
  }
  //api call to add/update Site
  UpdateSiteData(siteBody: any, button?: any) {
    button == 'SAVECLOSE'
      ? (this.isLoadingSaveClose = true)
      : (this.isLoadingOne = true);
    this._cpS.updateSite(siteBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cS.displayMessage('success', response.message);
        this.newSelectedSiteId = response.result?.id;
        this.newSiteAddUpdateData = response.result;
        if (button == 'SAVECLOSE') {
          this.isVisibleSiteDrawer = false;
          this.hideSiteDrawer.emit({
            hide: this.isVisibleSiteDrawer,
            data: response.result,
          });
          this.sitebutton = 'SAVECLOSE';
        } else {
          this.sitebutton = 'SAVE';
        }
        button == 'SAVECLOSE'
          ? (this.isLoadingSaveClose = false)
          : (this.isLoadingOne = false);
        this._cS.displayMessage('success', response.message);
        if (this.SelectedSiteTab == 1) {
          // this.updateSiteFormValidation(false);
        }
      } else {
        this._cS.displayMessage('error', response.message);
        button == 'SAVECLOSE'
          ? (this.isLoadingSaveClose = false)
          : (this.isLoadingOne = false);
      }
    });
  }

  getAllAccount() {
    this._iS
      .getAccountDropdownList(this.SelectedSiteTab == SiteType.Operator ? 1 : 2)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.listOfAccounts = response.result;
        }
      });
  }
  formatAmount(amount: any) {
    if (amount) {
      if (amount.toString().includes('$')) {
        amount = amount.split('$')[1];
      }
      amount = amount.toString().replace(',', '');
      this.currentStartingBalanceAmount = Number(amount);
      this._fS.siteForm.patchValue({
        startingBalance: this.currency.transform(amount),
      });
    }
  }
  getGenericPopulateRecords() {
    this.isLoadingQBOClass = true;
    // type:any ,searchFilter?:any ,startPosition?:any ,pageSize?:any ,sortOrder?:any
    this._cpS.getGenericPopulateRecords('1').subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfCategory = response.result.category;
        var findDefault = this.listOfCategory.find(
          (x: any) => x.name == 'Program Expense'
        );
        if (findDefault) {
          if (this.selectedSiteData == null) {
            this._fS.siteForm.patchValue({
              category: findDefault.id,
            });
          }
        }
        this.listOfProductService = response.result.service;
        const classOptions = (response.result.class || [])
          .filter((x: { name?: string }) => (x.name || '').split(':').length === 3)
          .map((x: {
            id: string;
            name: string;
            isMapped?: boolean;
            isActive?: boolean;
          }) => {
            const isActive = x.isActive !== false;
            const rawName = x.name || '';
            // Single status label: strip QBO "(deleted)" / "(inactive)" then use "(Inactive)" only when inactive.
            const baseName = rawName
              .replace(/\s*\(\s*deleted\s*\)/gi, '')
              .replace(/\s*\(\s*inactive\s*\)/gi, '')
              .trim();
            return {
              ...x,
              isActive,
              isMapped: !!x.isMapped,
              _uiLabel: isActive ? baseName : `${baseName} (Inactive)`,
            };
          })
          .sort(
            (
              a: { isActive: boolean; isMapped: boolean; name: string },
              b: { isActive: boolean; isMapped: boolean; name: string }
            ) => {
              if (a.isActive !== b.isActive) {
                return a.isActive ? -1 : 1;
              }
              if (a.isMapped !== b.isMapped) {
                return a.isMapped ? 1 : -1;
              }
              return (a.name || '').localeCompare(b.name || '');
            }
          );
        this.listOfTransactionClass = classOptions;

        this.isLoadingQBOClass = false;
      } else {
        this.isLoadingQBOClass = false;
        this.listOfTransactionClass = [];
      }
    });
  }
  preventDefaults(event: any) {
    event.preventDefault();
    return false;
  }
  getAccountDetails() {
    setTimeout(() => {
      if (
        this.listOfAccounts != null &&
        this.SelectedSiteTab != SiteType.Supplier
      ) {
        if (this.isSameAddressFlag) {
          const currentPermissionsRow = this.listOfAccounts.find(
            (x: any, i: any) => x.name == this._fS.siteForm.value.accountName
          );
          if (currentPermissionsRow) {
            this._fS.siteForm.patchValue({
              address1: currentPermissionsRow.address1,
              address2: currentPermissionsRow.address2,
              city: currentPermissionsRow.city,
              state: currentPermissionsRow.state,
              zipcode: currentPermissionsRow.zipcode,
              country: currentPermissionsRow.country,
            });
          }
        } else {
          if (this.selectedSiteData) {
            this._fS.siteForm.patchValue({
              address1: this.selectedSiteData.address1,
              address2: this.selectedSiteData.address2,
              city: this.selectedSiteData.city,
              state: this.selectedSiteData.state,
              zipcode: this.selectedSiteData.zipcode,
              country: this.selectedSiteData.country,
            });
          } else {
            this._fS.siteForm.patchValue({
              address1: '',
              address2: '',
              city: '',
              state: '',
              zipcode: '',
              country: 'USA',
            });
          }
        }
      }
    }, 500);
  }

  showDrawerPreferredPartners(data: any) {
    this.isVisiblePreferredPartnersDrawer = true;
    if (data) {
      this.selectedPreferredPartnersData = data;
    } else {
      this.selectedPreferredPartnersData = null;
    }
  }

  // ?-_-_  Program Period Tab All Listing and Open and Close -_-_-_-_???
  showDrawerProgramPeriod(data: any) {
    this.isVisibleProgramPeriodDrawer = true;
    if (data) {
      this.selectedProgramPeriodData = data;
    } else {
      this.selectedProgramPeriodData = null;
    }
  }
  showDeleteConfirmProgramP(data: any) {
    this.deleteProgramPConfirmVisible = true;
    this.selectedProgramPeriodData = data;
  }
  handleCancelProgramP() {
    this.deleteProgramPConfirmVisible = false;
  }
  hideProgramPDrawer(event: any) {
    this.isVisibleProgramPeriodDrawer = event.hide;
    if (event.data != null) {
      var existingId = this.getAllProgramPData.find(
        (role: any) => role.id === event.data.id
      );
      if (existingId) {
        this.selectedProgramPeriodData.id = event.data.id;
        this.selectedProgramPeriodData.label = event.data.label;
        this.selectedProgramPeriodData.startMonth = event.data.startMonth;
        this.selectedProgramPeriodData.endMonth = event.data.endMonth;
        this.selectedProgramPeriodData.shortStartMonth =
          event.data.shortStartMonth;
        this.selectedProgramPeriodData.shortEndMonth = event.data.shortEndMonth;
        this.selectedProgramPeriodData.startYear = event.data.startYear;
        this.selectedProgramPeriodData.endYear = event.data.endYear;
        this.selectedProgramPeriodData.isDefault = event.data.isDefault;
        this.selectedProgramPeriodData.isVisible = event.data.isVisible;
        this.selectedProgramPeriodData.linked = event.data.linked;
      } else {
        if (this.getAllProgramPData?.length > 99) {
          this.getAllPrograms();
        }
        this.getAllProgramPData.splice(1, 0, event.data);
        if (event.data.isDefault) {
          this.radioValue = event.data.id;
        }
        this.getAllProgramPData = [...this.getAllProgramPData];
      }
    }
  }
  // Api
  makeProgramDefault(event: any) {
    const formData = new FormData();
    formData.set('Id', event);
    formData.set('siteId', this.newSelectedSiteId);
    this._cpS.makeProgramDefault(formData).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        var program = this.getAllProgramPData.find(
          (item: any) => item.id == event
        );
        this.radioValue = program.id;
        this.getAllProgramPData.map((x: any) => (x.isDefault = false));
        program.isDefault = true;
        this.selectedProgramPeriodData.isDefault = true;
        this._cS.displayMessage('success', response.message);
      } else {
        this._cS.displayMessage('error', response.message);
      }
    });
  }
  updateProgramVisible(program: { id?: string; isVisible?: boolean }) {
    const previousVisibility = !program.isVisible;
    const programId = program.id || '';
    const formData = new FormData();
    formData.set('Id', programId);
    this._cpS.updateProgramVisible(formData).subscribe((response: any) => {
      if (response.responseStatus !== ResponseStatus.success) {
        program.isVisible = previousVisibility;
        this._cS.displayMessage('error', response.message);
        return;
      }

      const result = response.result;
      const anchorVisible =
        result?.isVisible ?? result?.IsVisible ?? program.isVisible;
      program.isVisible = anchorVisible;

      applyProgramVisibilityCascade(
        this.getAllProgramPData,
        programId,
        anchorVisible
      );
      this.getAllProgramPData = [...this.getAllProgramPData];

      if (this.selectedProgramPeriodData?.id === programId) {
        this.selectedProgramPeriodData.isVisible = program.isVisible;
      }
      this._cS.displayMessage('success', response.message);
    });
  }
  sortProgram(key: string) {
    if (key) {
      this.sortBy = this.sortBy == 'asc' ? 'desc' : 'asc';
      this.sortField = key;
      this.pageNumber = 1;
      this.getAllPrograms();
    }
  }

  getAllPrograms() {
    this.isDataLoaded = true;
    var requestBody = {
      searchText: this.searchTextProgramP,
      sortField: this.sortField,
      sortBy: this.sortBy,
      page: this.page,
      pageSize: this.pageSize,
      siteId: this.newSelectedSiteId,
    };
    this._cpS.getAllPrograms(requestBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isDataLoaded = false;
          this.getAllProgramPData = response.result.records;
          this.totalRecords = response.result.totalRecord;
          var defaultProgram = this.getAllProgramPData.find(
            (program: any) => program.isDefault == true
          );
          if (defaultProgram) {
            this.radioValue = defaultProgram.id;
          }
        } else {
          this.isDataLoaded = false;
          this._cS.displayMessage('error', response.message);
        }
      },
      (error: any) => {
        this.isDataLoaded = false;
      }
    );
  }
  deleteProgram() {
    this.deleteProgramPConfirmVisible = false;
    this._cpS.deleteProgram(this.selectedProgramPeriodData.id).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          this.getAllProgramPData = this.getAllProgramPData.filter(
            (data: any) => data.id !== this.selectedProgramPeriodData.id
          );
          this.loadingDeleteProgram = false;
        } else {
          this._cS.displayMessage('error', response.message);
          this.loadingDeleteProgram = false;
        }
      },
      (error: any) => {
        this.loadingDeleteProgram = false;
      }
    );
  }
  //search user
  searchProgram(event: any) {
    if (
      event.which != 9 &&
      event.which != 18 &&
      event.which != 13 &&
      event.which != 16 &&
      event.which != 27
    ) {
      clearTimeout(this.timer);
      if (this.searchTextProgramP) {
        this.timer = setTimeout(() => {
          this.page = 1;
          this.getAllPrograms();
        }, 1000);
      } else {
        if (this.searchTextProgramP == '') {
          this.oldSearchText = '';
          this.getAllPrograms();
        }
      }
    }
  }

  //pagination
  onQueryParamsChangeProgram(event: any) {
    this.pageNumber = event;
    this.getAllPrograms();
  }

  // ?-_-_  Preferred Patner or InvestorAPi Tab All Listing and Open and Close -_-_-_-_???
  hidePPartnerDrawer(event: any) {
    this.isVisiblePreferredPartnersDrawer = event.hide;
    if (event.data != null) {
      var existingId = this.getAllPPartnersData.find(
        (user: any) => user.id === event.data.id
      );
      if (existingId) {
        // this.selectedPPartnerData.id = event.data.id;
        // this.selectedPPartnerData.emailDefaults = event.data.emailDefaults;
        // this.selectedPPartnerData.isActive = event.data.isActive;
      } else {
        if (this.getAllPPartnersData?.length > 99) {
          this.getAllPPartners();
        }
        this.getAllPPartnersData?.splice(0, 0, event.data);
        this.getAllPPartnersData = [...this.getAllPPartnersData];
      }
    }
  }
  getAllPPartners() {
    this.isDataLoaded = true;
    var requestBody = {
      searchText: this.searchText,
      sortField: this.sortField,
      sortBy: this.sortBy,
      page: this.page,
      pageSize: this.pageSize,
      siteId: this.newSelectedSiteId,
    };
    this._cpS.getAllPPartners(requestBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.isDataLoaded = false;
        this.getAllPPartnersData = response.result.records;
        this.totalRecords = response.result.totalRecord;
      } else {
        this.isDataLoaded = false;
        this._cS.displayMessage('error', response.message);
      }
    });
  }
  //search user
  searchPPartners(event: any) {
    if (
      event.which != 9 &&
      event.which != 18 &&
      event.which != 13 &&
      event.which != 16 &&
      event.which != 27
    ) {
      clearTimeout(this.timer);
      if (this.searchText) {
        this.timer = setTimeout(() => {
          this.pageNumber = 1;
          this.getAllPPartners();
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.oldSearchText = '';
          this.getAllPPartners();
        }
      }
    }
  }
  //pagination
  onQueryParamsChangePPartners(event: any) {
    this.pageNumber = event;
    this.getAllPPartners();
  }
  deletePPartners() {
    this.deletePPartnersConfirmVisible = false;
    this._cpS.deletePPartner(this.selectedPreferredPartnersData.id).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          this.getAllPPartnersData = this.getAllPPartnersData.filter(
            (data: any) => data.id !== this.selectedPreferredPartnersData.id
          );
          if (this.getAllPPartnersData.length < 3) {
            this.getAllPPartners();
          }
          this.loadingDeleteProgram = false;
        } else {
          this._cS.displayMessage('error', response.message);
          this.loadingDeleteProgram = false;
        }
      },
      (error: any) => {
        this.loadingDeleteProgram = false;
      }
    );
  }
  handleCancelPPartners() {
    this.deletePPartnersConfirmVisible = false;
  }
  showDeleteConfirmPPartners(data: any) {
    this.deletePPartnersConfirmVisible = true;
    this.selectedPreferredPartnersData = data;
  }

  //add new investor from database dropdown list
  addPartnerToList(investor: any) {
    this.currentAddingInvestor = investor;
    this.isDeletingInvestor = true;
    const formData = new FormData();
    formData.set('investorId', investor._id);
    formData.set('siteId', this.newSelectedSiteId);
    this._cpS.AddPartnerFromDB(formData).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isDeletingInvestor = false;
          if (this.getAllPPartnersData?.length > 99) {
            this.getAllPPartners();
          }
          this.getAllPPartnersData?.splice(0, 0, response.result);
          this.getAllPPartnersData = [...this.getAllPPartnersData];
          var index = this.partnerDBList.findIndex(
            (x: any) => x._id == investor._id
          );
          this.partnerDBList[index].isAlreadyAdded = true;
          this._cS.displayMessage('success', response.message);
        } else {
          this.isDeletingInvestor = false;
          this._cS.displayMessage('error', response.message);
        }
      },
      (error: any) => {
        this.isDeletingInvestor = false;
      }
    );
  }
  //get investors from db in dropdown
  getAllDBPartners() {
    this.isLoadingPartnerSearch = true;
    this._cpS
      .searchInDatabasePartner(this.searchText.trim(), this.newSelectedSiteId)
      .subscribe(
        (response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.partnerDBList = response.result;
            this.isLoadingPartnerSearch = false;
          } else {
            this._cS.displayMessage('error', response.message);
            this.isLoadingPartnerSearch = false;
          }
        },
        (error: any) => {
          this.isDataLoaded = false;
        }
      );
  }

  //search supplier
  searchPartner(event: any) {
    this.searchText = event;
    if (
      event.which != 9 &&
      event.which != 18 &&
      event.which != 13 &&
      event.which != 16 &&
      event.which != 27
    ) {
      clearTimeout(this.timer);
      if (this.searchText) {
        this.timer = setTimeout(() => {
          this.pageNumber = 1;
          this.getAllDBPartners();
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.oldSearchText = '';
          this.getAllDBPartners();
        }
      }
    }
  }

  sortPartner(index: any, key: any, event: any) {
    if (key) {
      this.sortBy = event == 'ascend' ? 'asc' : 'desc';
      this.sortField = event ? key : 'CompanyName';
      this.colsPartners.forEach((element) => {
        element.sortDir = null;
      });
      this.colsPartners[index].sortDir = event;
      this.page = 1;
      this.getAllPPartners();
    }
  }

  redirectStartingBalance() {
    this.tabIndex = 0;
    setTimeout(() => {
      this.startingBalanceFocus.first.nativeElement.focus();
    }, 200);
  }
  redirectDate() {
    this.tabIndex = 0;
    setTimeout(() => {
      this.datePick.first.elementRef.nativeElement.focus();
    }, 200);
  }

  focusAddress(event) {
    if (event) {
      this.address1Field.nativeElement.focus();
    }
  }
  focusZipCode(event) {
    if (event && !this.selectedSiteData) {
      this.zipcode.nativeElement.focus();
    }
  }
  focusCategoryDD(event) {
    if (event && !this.selectedSiteData) {
      this.categoryDD.focus();
    }
  }
  focusflag = false;
  focusProductDD(event) {
    if (this.selectedSiteData != null) {
      this.focusflag = true;
    }
    if (this.focusflag) {
      if (event) {
        this.productDD.focus();
      }
    } else {
      this.focusflag = true;
    }
  }
  focusProcessFee(event) {
    if (event) {
      this.processFee.nativeElement.focus();
    }
  }

  // ?-_-_  Preferred Vendors Tab All Listing -_-_-_-_???
  getAllPVendors() {
    this.isDataLoaded = true;
    this._iS
      .getAllvendors(
        this.newSelectedSiteId,
        this.pageNumber,
        this.pageRecord,
        this.sortBy,
        this.sortField
      )
      .subscribe(
        (response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.isDataLoaded = false;
            this.apiAllVendorsData = response.result.records;
            this.totalRecords = response.result.totalRecord;
          } else {
            this.isDataLoaded = false;
            this._cS.displayMessage('error', response.message);
          }
        },
        (error: any) => {
          this.isDataLoaded = false;
        }
      );
  }
  hidePVendorsDrawer(event: any) {
    this.isVisiblePreferredVendorsDrawer = event.hide;
    if (event.data != null) {
      var existingId = this.apiAllVendorsData.find(
        (user: any) => user.id === event.data.id
      );
      if (existingId) {
        // this.selectedPreferredVData.id = event.data.id;
        // this.selectedPreferredVData.emailDefaults = event.data.emailDefaults;
        // this.selectedPreferredVData.isActive = event.data.isActive;
      } else {
        if (this.apiAllVendorsData?.length > 99) {
          this.getAllPVendors();
        }
        this.apiAllVendorsData?.splice(0, 0, event.data);
        this.apiAllVendorsData = [...this.apiAllVendorsData];
      }
    }
  }
  showDrawerPreferredVendors(data: any) {
    this.isVisiblePreferredVendorsDrawer = true;
    if (data) {
      this.selectedPreferredVendorsData = data;
    } else {
      this.selectedPreferredVendorsData = null;
    }
  }
  showDeleteConfirmPVendors(data: any) {
    this.deletePVendorsConfirmVisible = true;
    this.selectedPreferredVData = data;
  }
  handleCancelPVendors() {
    this.deletePVendorsConfirmVisible = false;
  }
  deletePVendors() {
    this.deletePVendorsConfirmVisible = false;
    this._cpS.deletePVendors(this.selectedPreferredVData.id).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          this.apiAllVendorsData = this.apiAllVendorsData.filter(
            (data: any) => data.id !== this.selectedPreferredVData.id
          );
          if (this.apiAllVendorsData.length < 3) {
            this.getAllPVendors();
          }
          this.loadingDeleteProgram = false;
        } else {
          this._cS.displayMessage('error', response.message);
          this.loadingDeleteProgram = false;
        }
      },
      (error: any) => {
        this.loadingDeleteProgram = false;
      }
    );
  }
  onQueryParamsChangePVendors(event: any) {
    this.pageNumber = event;
    this.getAllPVendors();
  }

  //add new vendor from database dropdown list
  addVendorToList(vendor: any) {
    this.currentAddingVendor = vendor;
    this.isDeletingVendor = true;
    const formData = new FormData();
    formData.set('vendorId', vendor._id);
    formData.set('siteId', this.newSelectedSiteId);
    this._cpS.AddVendorFromDB(formData).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isDeletingVendor = false;
          if (this.apiAllVendorsData?.length > 99) {
            this.getAllPVendors();
          }
          this.apiAllVendorsData?.splice(0, 0, response.result);

          this.apiAllVendorsData = [...this.apiAllVendorsData];
          var index = this.vendorsDBList.findIndex(
            (x: any) => x._id == vendor._id
          );
          this.vendorsDBList[index].IsAlreadyAdded = true;
          this._cS.displayMessage('success', response.message);
        } else {
          this.isDeletingVendor = false;
          this._cS.displayMessage('error', response.message);
        }
      },
      (error: any) => {
        this.isDeletingVendor = false;
      }
    );
  }
  searchVendor(event: any) {
    this.searchText = event;
    if (
      event.which != 9 &&
      event.which != 18 &&
      event.which != 13 &&
      event.which != 16 &&
      event.which != 27
    ) {
      clearTimeout(this.timer);
      if (this.searchText) {
        this.timer = setTimeout(() => {
          this.startPosition = 1;
          this.getAllDBVendors();
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.oldSearchText = '';
          this.getAllDBVendors();
        }
      }
    }
  }
  //get all vendors in dropdown from db
  getAllDBVendors() {
    this.isLoadingVendorSearch = true;
    this._cpS
      .searchInDatabase(this.searchText.trim(), this.newSelectedSiteId)
      .subscribe(
        (response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.vendorsDBList = response.result;
            this.isLoadingVendorSearch = false;
          } else {
            this._cS.displayMessage('error', response.message);
            this.isLoadingVendorSearch = false;
          }
        },
        (error: any) => {
          this.isDataLoaded = false;
        }
      );
  }
  sortVendors(index: any, key: any, event: any) {
    if (key) {
      this.sortBy = event == 'descend' ? 'desc' : 'asc';
      this.sortField = event ? key : 'VendorDisplayName';
      this.colsVendors.forEach((element) => {
        element.sortDir = null;
      });
      this.colsVendors[index].sortDir = event;
      this.page = 1;
      this.getAllPVendors();
    }
  }
  sortNonAlcData(index: any, key: any, event: any) {
    if (key) {
      this.sortBy = event == 'ascend' ? 'asc' : 'desc';
      this.sortField = event ? key : 'Date';
      this.colsNonAlc.forEach((element) => {
        element.sortDir = null;
      });
      this.colsNonAlc[index].sortDir = event;
      this.page = 1;
      this.getAllNonAlcData();
    }
  }

  //Tags
  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }
  //pagination
  onQueryParamsChange(event: any) {
    this.pageNumber = event;
    this.getAllTags(true);
  }

  sort(key: any, event: any) {
    if (key) {
      this.sortBy = event == 'descend' ? 'desc' : 'asc';
      this.sortField = event ? key : 'Name';
      // this.tagNameOrder = event;
      this.pageNumber = 1;
      this.getAllTags(true);
    }
  }
  sortTags(tagGroupData: any, index: any, sortOrder: any) {
    if (sortOrder == 'desc')
      tagGroupData.sort((a: any, b: any) =>
        a['name'] < b['name'] ? 1 : b['name'] < a['name'] ? -1 : 0
      );
    if (sortOrder == 'asc')
      tagGroupData.sort((a: any, b: any) =>
        a['name'] > b['name'] ? 1 : b['name'] > a['name'] ? -1 : 0
      );
    this.tagGroupData[index].tags = [...tagGroupData];
    this.tagGroupData[index].sortOrder = sortOrder;
  }
  getAllTags(loading?: any) {
    if (loading) {
      this.isDataLoaded = true;
    }
    var requestBody = {
      searchText: this.searchText.trim(),
      sortField: this.sortField,
      sortBy: this.sortBy,
      page: this.pageNumber,
      pageSize: this.pageRecord,
      siteId: this.newSelectedSiteId,
    };
    this._cpS.getAllTags(requestBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          if (loading) {
            this.isDataLoaded = false;
          }
          this.tagGroupData = response.result.records;
          this.totalRecords = response.result.totalRecord;
          this.listOfGroups = this.tagGroupData.map((x: any) => {
            return {
              id: x.id,
              name: x.name,
            };
          });
          this.tagGroupData.forEach((element) => {
            element.sortOrder = null;
          });
        } else {
          if (loading) {
            this.isDataLoaded = false;
          }
          this._cS.displayMessage('error', response.message);
        }
      },
      (error: any) => {
        if (loading) {
          this.isDataLoaded = false;
        }
      }
    );
  }

  //on click save after on adding tag group name and color
  addTagGroup() {
    if (this._fS.tagsGroupForm.valid) {
      this.isLoadingTagGroup = true;
      this.handleOkTag(true);
    } else {
      Object.values(this._fS.tagsGroupForm.controls).forEach((control: any) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  addTagstoGroup() {
    if (!/.*\S.*/.test(this.tagname)) {
      this.invalidtagname = true;
    } else {
      this.invalidtagname = false;
      // this.tags.push({ id: '', name: this.tagname, transcationids: [] });
      // this.tagsCopy.push({ id: '', name: this.tagname, transcationids: [] });
      // this.tagname = '';
      this.handleOkTag();
    }
  }
  // on click new tag group to show modal
  VisibleTagGroup(data: any) {
    this.isVisibleTagGroup = true;
    this.tags = [];
    this._fS.tagsGroupForm.reset();
    this.color = '#000105';
    this.selectedTagGroupData = data;
    if (this.selectedTagGroupData != null) {
      this.isEnableButton = true;
      this.groupTitle = 'Edit Tag Group';
      this._fS.tagsGroupForm.patchValue({
        tagGroupName: this.selectedTagGroupData.name,
        // tagGroupColor: this.selectedTagGroupData.color,
      });
      this.color = this.selectedTagGroupData.color;
      this.tags = this.selectedTagGroupData.tags;
      document.documentElement.style.setProperty(
        '--tag-group-color',
        // this._fS.tagsGroupForm.value.tagGroupColor
        this.color
      );
    } else {
      this.groupTitle = 'Add Tag Group';
    }
  }
  removeTag(index: any) {
    this.tags.splice(index, 1);
  }

  removeTagFromTagsCopy(index: any) {
    this.tagsCopy.splice(index, 1);
  }

  //search user
  searchTag(event: any) {
    if (
      event.which != 9 &&
      event.which != 18 &&
      event.which != 13 &&
      event.which != 16 &&
      event.which != 27
    ) {
      clearTimeout(this.timer);
      if (this.searchText) {
        this.timer = setTimeout(() => {
          this.pageNumber = 1;
          this.getAllTags(true);
        }, 1000);
      } else {
        if (this.searchText == '') {
          this.oldSearchText = '';
          this.getAllTags(true);
        }
      }
    }
  }

  handleOkTag(isSaveClicked?: boolean): void {
    if (this._fS.tagsGroupForm.valid) {
      const formvalue = this._fS.tagsGroupForm.value;
      // this.tagGroupData.push({response})
      let tagsArrayToPass: any[] = [];
      if (this.tagname != '') {
        tagsArrayToPass = this.tags.concat([
          {
            id: '',
            name: this.tagname,
          },
        ]);
      } else {
        tagsArrayToPass = this.tags;
      }
      var tagGroupBody = {
        name: formvalue.tagGroupName,
        siteId: this.newSelectedSiteId,
        color: this.color,
        // tags: this.tags,
        tags: tagsArrayToPass,
        id:
          this.selectedTagGroupData == null ? '' : this.selectedTagGroupData.id,
      };
      this.selectedTagGroupData == null
        ? this.createNewTagGroup(tagGroupBody)
        : this.editTagGroup(tagGroupBody, isSaveClicked);
    } else {
      Object.values(this._fS.tagsGroupForm.controls).forEach((control: any) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  editTagGroup(tagGroupBody: any, isSaveClicked: boolean = false) {
    if (!isSaveClicked) {
      this.isLoadingTag = true;
    }
    this._cpS.updateTagGroup(tagGroupBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.tags = response.result.tags;
          this.tagname = '';
          var index = this.tagGroupData.findIndex(
            (x: any) => x.id == response.result.id
          );
          this.tagGroupData[index].name = response.result.name;
          this.tagGroupData[index].color = response.result.color;
          this.tagGroupData[index].tags = response.result.tags;
          this.tagGroupData[index].tags = [...this.tagGroupData[index].tags];

          // this.tags = [];
          this.isLoadingTag = false;
          this.isLoadingTagGroup = false;
          // this.handleCancelTag();
        } else {
          this.isLoadingTag = false;
          this.isLoadingTagGroup = false;
          this._cS.displayMessage('error', response.message);
        }
      },
      (error: any) => {
        this.isLoadingTag = false;
      }
    );
  }
  createNewTagGroup(tagGroupBody: any) {
    // this.isLoadingTag = true;
    this._cpS.addTagGroup(tagGroupBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isTagGroupAdded = true;
          this.isEnableButton = true;

          document.documentElement.style.setProperty(
            '--tag-group-color',
            // this._fS.tagsGroupForm.value.tagGroupColor
            this.color
          );

          const newData = response.result;

          this.tagGroupData.splice(1, 0, {
            id: newData.id,
            name: newData.name,
            color: newData.color,
            tags: newData.tags,
          });

          this.selectedTagGroupData = response.result;

          this.tagGroupData = [...this.tagGroupData];
          if (this.tagGroupData?.length > 99) {
            this.getAllTags();
          }
          // this.isTagGroupAdded = false;
          // this.tags = [];
          this.isLoadingTagGroup = false;
          // this.handleCancelTag();
        } else {
          this.isLoadingTagGroup = false;
          this._cS.displayMessage('error', response.message);
        }
      },
      (error: any) => {
        this.isLoadingTagGroup = false;
      }
    );
  }

  handleCancelTag(): void {
    this.isVisibleTagGroup = false;
    this.isTagGroupAdded = false;
    this.tagsCopy = [];
    this.isEnableButton = false;
    this.tagname = '';
  }

  VisibleTag(tagGroupdata: any, data: any): void {
    this._fS.tagForm.reset();
    this.isVisibleTag = true;
    this.selectedTagData = data;
    this.getAllTags(false);
    if (this.selectedTagData != null) {
      this.tagTitle = 'Edit Tag';
      this._fS.tagForm.patchValue({
        tagName: this.selectedTagData.name,
        tagGroup: tagGroupdata.id,
      });
    } else {
      this.tagTitle = 'Add Tag';
    }
  }

  handleOkisVisibleTag() {
    if (this._fS.tagForm.valid) {
      const formvalue = this._fS.tagForm.value;
      var tagBody = {
        tagGroupId: formvalue.tagGroup,
        tagName: formvalue.tagName,
        tagId: this.selectedTagData == null ? '' : this.selectedTagData.id,
      };
      this.selectedTagData == null
        ? this.createNewTag(tagBody)
        : this.editTag(tagBody);
    } else {
      Object.values(this._fS.tagForm.controls).forEach((control: any) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }
  createNewTag(tagBody: any) {
    this.isLoadingTag = true;
    this._cpS.addTag(tagBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          const newData = response.result;
          var dataToAdd: any = this.tagGroupData.find(
            (item: any) => item.id == newData.id
          );
          dataToAdd.tags = newData.tags;
          dataToAdd.tags = [...dataToAdd.tags];
          this.isLoadingTag = false;
          this.handleCancelisVisibleTag();
        } else {
          this.isLoadingTag = false;
        }
      },
      (error: any) => {
        this.isLoadingTag = false;
      }
    );
  }
  editTag(tagBody: any) {
    this.isLoadingTag = true;
    this._cpS.updateTag(tagBody).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          var index = this.tagGroupData.findIndex(
            (x: any) => x.id == response.result.id
          );
          this.tagGroupData[index].tags = response.result.tags;

          this.isLoadingTag = false;
          this.handleCancelisVisibleTag();
        } else {
          this.isLoadingTag = false;
        }
      },
      (error: any) => {
        this.isLoadingTag = false;
      }
    );
  }
  handleCancelisVisibleTag() {
    this.isVisibleTag = false;
  }
  handleCancelDelete() {
    this.deleteConfirmVisible = false;
  }

  deleteData() {
    this.deleteConfirmVisible = false;
    this.isDeletingTag = true;
    this.selectedData.color ? this.deleteTagGroup() : this.deleteTag();
  }

  deleteTagGroup() {
    this._cpS.deleteTagGroup(this.selectedData.id).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.deleteConfirmVisible = false;
          this.isDeletingTag = false;
          this._cS.displayMessage('success', response.message);

          this.tagGroupData = this.tagGroupData.filter(
            (data: any) => data.id !== this.selectedData.id
          );
        } else {
          this._cS.displayMessage('error', response.message);
          this.deleteConfirmVisible = false;
          this.isDeletingTag = false;
        }
      },
      (error: any) => {
        this.deleteConfirmVisible = false;
        this.isDeletingTag = false;
      }
    );
  }

  deleteTag() {
    this._cpS
      .deleteTag(this.selectedTagGroupData.id, this.selectedData.id)
      .subscribe(
        (response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.deleteConfirmVisible = false;
            this.isDeletingTag = false;
            this._cS.displayMessage('success', response.message);

            var index = this.tagGroupData.findIndex(
              (x: any) => x.id == response.result.id
            );
            this.tagGroupData[index].tags = response.result.tags;
          } else {
            this._cS.displayMessage('error', response.message);
            this.deleteConfirmVisible = false;
            this.isDeletingTag = false;
          }
        },
        (error: any) => {
          this.deleteConfirmVisible = false;
          this.isDeletingTag = false;
        }
      );
  }

  //showDeleteConfirm
  showDeleteConfirm(tagGroupdata: any, data: any) {
    this.deleteConfirmVisible = true;
    this.selectedData = data;
    this.selectedTagGroupData = tagGroupdata;
  }

  //pagination
  onQueryParamsChangeTag(event: any) {
    this.pageNumber = event;
    this.getAllTags();
  }

  defaultColors: any[] = [
    { color: '#0077C5', class: 'blue' },
    { color: '#00A6A4', class: 'persianGreen' },
    { color: '#2CA01C', class: 'green' },
    { color: '#6B6C72', class: 'dolphin' },
    { color: '#34BFFF', class: 'lightBlue' },
    { color: '#00D7D7', class: 'darkTurquoise' },
    { color: '#A9E838', class: 'parrotGreen' },
    { color: '#BABEC5', class: 'violet' },
    { color: '#A898FF', class: 'Melrose' },
    { color: '#FF88EC', class: 'pink' },
    { color: '#FF8979', class: 'vividTangerine' },
    { color: '#FFBB00', class: 'orange' },
    { color: '#6436AF', class: 'purple' },
    { color: '#C9007A', class: 'magenta' },
    { color: '#D52B1E', class: 'maroon' },
    { color: '#FFAC61', class: 'peach' },
  ];
  show = false;
  heading: string = '';

  public toggleColors() {
    this.show = !this.show;
  }

  public changeColor(paint: any) {
    this.color = paint.color;
    // this.event.emit(this.color); // Return color
    this.show = false;
  }
  public changeColorManual(color: string) {
    const isValid = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);

    if (isValid) {
      this.color = color;
      // this.event.emit(this.color); // Return color
    }
  }

  onQueryParamsChangeNonAlc(event: any) {
    this.pageNumber = event;
    this.getAllNonAlcData();
  }

  //Non_alc Listing
  getAllNonAlcData() {
    this.getSelectedfilters();
    this.isDataLoaded = true;
    this._iS
      .getAllNonAlcData(
        this.newSelectedSiteId,
        this.pageNumber,
        this.pageRecord,
        this.sortBy,
        this.sortField,
        this.selectedTransactionTypes
      )
      .subscribe(
        (response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this.isDataLoaded = false;
            this.apiAllNonAlcData = response.result.transaction;
            this.totalRecords = response.result.totalRecord;
            this.nonalcResult = response.result;
            this.dateNonAlc = this.nonalcResult.nonAlcDate.includes('0001')
              ? this.today
              : this.nonalcResult.nonAlcDate;
          } else {
            this.isDataLoaded = false;
            this._cS.displayMessage('error', response.message);
          }
        },
        (error: any) => {
          this.isDataLoaded = false;
        }
      );
  }

  //show transaction modal
  showTransactionModal(event: any) {
    if (event?.transactionsType == TransactionsType.Investment) {
      this.isVisibleInvestmentModal = true;
      event['id'] = event['transactionsId'];
    } else if (event?.transactionsType == TransactionsType.Payment) {
      event['_id'] = event['transactionsId'];
      this.isVisibleBillModal = true;
    } else if (event?.transactionsType == TransactionsType.Expenses) {
      event['_id'] = event['transactionsId'];
      this.isVisibleExpenseModal = true;
    } else if (event?.transactionsType == TransactionsType.InternalTransfer) {
      event['id'] = event['transactionsId'];
      this.isVisibleITModal = true;
    } else if (event?.transactionsType == TransactionsType.Refunds) {
      event['id'] = event['transactionsId'];
      this.isVisibleRefundModal = true;
    } else if (event?.transactionsType == TransactionsType.Credits) {
      event['id'] = event['transactionsId'];
      this.isVisibleCreditModal = true;
    } else if (event?.transactionsType == TransactionsType.Deposits) {
      event['id'] = event['transactionsId'];
      this.isVisibleDepositModal = true;
    }
    if (event) {
      this.selectedData = event;
      this.selectedData['id'] = event['transactionsId'];
      this.selectedData['_id'] = event['transactionsId'];
    } else {
      this.selectedData = null;
    }
  }

  hideEstimateDrawer(event: any) {
    this.isVisibleInvestmentModal = event.hide;
    this.isVisibleBillModal = event.hide;
    this.isVisibleExpenseModal = event.hide;
    this.isVisibleITModal = event.hide;
    this.isVisibleRefundModal = event.hide;
    this.isVisibleCreditModal = event.hide;
    this.isVisibleDepositModal = event.hide;
    this.getAllNonAlcData();
  }

  updateNonalcDetails(field: any) {
    this.isUpdatingDetails = true;
    var nonAlcDetailsBody = {
      SiteId: this.selectedSiteData.id,
      NonAlcDate: moment(this.dateNonAlc).utc().format(),
      StartingNonAlcBal: this.startingBalanceNonAlc,
    };
    this._cpS
      .updateNonAlcDetails(nonAlcDetailsBody)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          var nonAlcDetails = response.result?.item1;
          this.nonalcResult.startingBalance = nonAlcDetails.startingNonAlcBal;
          this.nonalcResult.nonAlcDate = nonAlcDetails.nonAlcDate;
          this.nonalcResult.currentBalance =
            response.result?.item2?.currentBalance;
          this.isVisibleStartingBalancePopover = false;
          this.isVisibleDatePopover = false;
          this.isUpdatingDetails = false;
          this._cS.displayMessage('success', response.message);
        } else {
          this.isUpdatingDetails = false;
          this._cS.displayMessage('success', response.message);
        }
      });
  }

  syncClasses() {
    if (!this.openClassDD) {
      this.openClassDD = true;
    }
    this.isLoadingQBOClass = true;
    this._iS.getQBOClass().subscribe((response: any) => {
      this.getGenericPopulateRecords();
    });
  }

  exportNonAlcCreditTransactions() {
    this.isExportingData = true;
    this._cpS
      .exportNonAlcTransactions(
        this.newSelectedSiteId,
        this.pageNumber,
        this.pageRecord,
        this.sortBy,
        this.sortField,
        this.selectedTransactionTypes
      )
      .subscribe((response: any) => {
        if (response) {
          if (response.type == 'application/json') {
            this.isExportingData = false;
            this._cS.displayMessage('warning', 'No records found to export!');
          } else {
            const downloadUrl = window.URL.createObjectURL(response);
            var a = document.createElement('a');
            a.href = downloadUrl;
            const date = this._datepipe.transform(new Date(), 'MM-dd-yyyy');
            const siteTypeName = this.selectedSiteData?.name;
            a.download = 'Non-Alc ' + siteTypeName + ' Site ' + date + '.xlsx';
            a.click();
            this.isExportingData = false;
          }
        } else {
          this.isExportingData = false;
        }
      });
  }

  change(event: any) {
    this.startingBalanceNonAlc = this.nonalcResult?.startingBalance;
    // this.dateNonAlc = this.nonalcResult?.nonAlcDate;
  }

  //Code added by Dev Dasani (12-06-25)
  filterVisibleChange(event, col: any) {
    if (!event) {
      this.colsNonAlc.forEach((item) => {
        if (item.title === 'Transaction Type') {
          item.filterOptions = [...(this.listOfTransactionsTypes || [])];
        }
      });
      col.filteredFilterOptions = col.filterOptions ? [...col.filterOptions] : [];
      col.isVisible = false;
      this.colsNonAlc = [...this.colsNonAlc];
    }
    // if (!event) {
    //   this.colsNonAlc.forEach((item) => {
    //     if (item.title === 'Transaction Type') {
    //       item.filterOptions = this.listOfTransactionsTypes;
    //       item.filterOptions = [...item.filterOptions];
    //     }
    //   });

    //   if (this.selectedFilters[col.title].length == 0) {
    //     col.filterOptions.forEach((element) => {
    //       element.checked = false;
    //     });
    //   } else {
    //     col.filterOptions.forEach((element) => {
    //       element.checked = false;
    //       this.selectedFilters[col.title].forEach((item) => {
    //         if (element.value == item) {
    //           element.checked = true;
    //         }
    //       });
    //     });
    //   }
    //   col.isVisible = false;
    //   col.filteredFilterOptions = col.filterOptions;
    //   this.colsNonAlc = [...this.colsNonAlc];
    // }
  }

  // searchFromFilterOptions(col: any) {
  //   const searchLower = this.filterSearchValue.trim().toLowerCase();

  //   if (!searchLower) {
  //     if (col?.filteredFilterOptions.length) {
  //       col.filterOptions = JSON.parse(
  //         JSON.stringify(col?.filteredFilterOptions)
  //       );
  //     }
  //   } else {
  //     let filteredTableDataTmp = col?.filteredFilterOptions.filter((item) => {
  //       const matchesSite = item.label.toLowerCase().includes(searchLower);

  //       return matchesSite;
  //     });

  //     col.filterOptions = filteredTableDataTmp;
  //   }
  // }


  applyFilters() {
    this.page = 1;
    this.getAllNonAlcData();
  }

  getNonAlcTransactionTypeFilters() {
    this._cpS
      .getNonAlcTransactionFilters(this.selectedSiteData?.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          const enumValues = Object.values(NonAlcSitesTransactionType).filter(
            (v): v is NonAlcSitesTransactionType => typeof v === 'number'
          );

          const matchedValues = enumValues.filter((v) =>
            response?.result?.transactionsTypes.includes(v)
          );

          const mappedOptions = matchedValues.map((value) => ({
            label: NonAlcSitesTransactionType[value],
            value,
            checked: false,
          }));

          this.listOfTransactionsTypes = [...mappedOptions];
        }
      });
  }

  setDefaultFilters() {
    this.selectedFilter = 'active';
    //find status column and add filter options
    this.colsNonAlc.forEach((element) => {
      if (element.isFilterable) {
        if (element.title === 'Transaction Type') {
          element.filterOptions = this.listOfTransactionsTypes;
        }

        element.filteredFilterOptions = JSON.parse(
          JSON.stringify(element.filterOptions)
        );
      }
    });
    this.getAllNonAlcData();
  }

  filterOK(col: any) {
    this.selectedFilters[col.title] = [...(col.selectedValues || [])];
    col.isFilterActive = (col.selectedValues || []).length > 0;
    col.isVisible = false;
    this.filterVisibleChange(false, col);
    this.applyFilters();
  }

  getSelectedfilters() {
    this.selectedTransactionTypes = '';
    if (this.selectedFilters['Transaction Type']?.length) {
      this.selectedTransactionTypes =
        this.selectedFilters['Transaction Type'].toString();
    }
  }

  resetFilters(callAPI: boolean = true, type?: string) {
    if (type) {
      this.selectedFilters[type] = [];
      this.colsNonAlc.forEach((item) => {
        if (item.title === type) {
          if (item.selectedValues) item.selectedValues = [];
          item.filterOptions = [...(this.listOfTransactionsTypes || [])];
          item.isFilterActive = false;
          item.isVisible = false;
          this.filterVisibleChange(false, item);
        }
        if (item.filterOptions) {
          item.filterOptions = [...item.filterOptions];
        }
      });
      this.applyFilters();
    } else {
      this.colsNonAlc.forEach((item) => {
        if (item.title === 'Transaction Type') {
          item.filterOptions = [...(this.listOfTransactionsTypes || [])];
        }
        item.isFilterActive = false;
        if (item.isFilterable && item.selectedValues) item.selectedValues = [];
        if (item.filterOptions) {
          item.filterOptions = [...item.filterOptions];
        }
      });
      this.selectedFilters = {
        'Transaction Type': [],
      };
      if (callAPI) {
        this.applyFilters();
      }
    }
    sessionStorage.setItem(
      'selectedFilters',
      JSON.stringify(this.selectedFilters)
    );
  }
}
